import { Component, Host, h, type JSX, Prop } from '@stencil/core'

@Component({
    tag: 'bar-component',
    styleUrl: 'bar-component.scss',
    shadow: false,
})

export class BarComponent {
    /** Lowest value */
    @Prop() min: number = 0
    /** Highest value */
    @Prop() max: number = 100
    /** Value to display */
    @Prop() value: number = 90
    /** orientation [horizontal|vertical] */
    @Prop() orientation: string = 'horizontal'

    /* @part indicator The close button displayed in the top right corner of the dialog. */

    render (): JSX.Element {
        return (
            <Host>
                <div class={`bar-component bar-${this.orientation}`} style={{ '--size': `${((this.value - this.min) / (this.max - this.min)) * 100}%` }} part={'background'}>
                    <div class="bar-container" >
                        <div class="bar-indicator" part={'indicator'} />
                    </div>
                </div>
            </Host>
        )
    }
}
